import {match} from 'ts-pattern';

import {
  useLazyGetCashReceiptV4Query,
  useRenderExpenseCashReceiptDocumentMutation,
  useRenderIncomeCashReceiptDocumentMutation,
} from '@dms/api/finance';

import {openFile} from 'shared/web';

import {handleApiError} from '../utils/handleApiError';

export function useOpenCashReceipt() {
  const [renderIncomeCashReceipt, {isLoading: isRenderingIncomeCashReceipt}] =
    useRenderIncomeCashReceiptDocumentMutation();

  const [renderExpenseCashReceipt, {isLoading: isRenderingExpenseCashReceipt}] =
    useRenderExpenseCashReceiptDocumentMutation();

  const [getCashReceipt, {isLoading: isLoadingCashReceipt}] = useLazyGetCashReceiptV4Query();

  const openCashReceipt = async (cashRegisterDocumentId: string) => {
    const cashReceiptType = await getCashReceipt({cashRegisterDocumentId})
      .unwrap()
      .then((data) => data.type);

    const renderAction = match(cashReceiptType)
      .with('income', () => renderIncomeCashReceipt)
      .with('expense', () => renderExpenseCashReceipt)
      .exhaustive();

    renderAction({
      renderDocumentRequestBody: {cashRegisterDocumentId},
    })
      .unwrap()
      .then((data) => data.pdfUrl)
      .then(openFile)
      .catch(handleApiError);
  };

  return {
    openCashReceipt,
    isRenderingIncomeCashReceipt,
    isRenderingExpenseCashReceipt,
    isRenderingCashReceipt: isRenderingIncomeCashReceipt || isRenderingExpenseCashReceipt,
    isLoadingCashReceipt,
  };
}
